import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {UserCollectionsService} from '../user-collections.service';
import {AuthService} from '../../../auth.service';
import {PageResult} from '../../../../shared/page-result';
import {UserCollectionDtoInterface} from '../dto/user-collection-dto';
import {BehaviorSubject} from 'rxjs';
import {MessageService} from '../../../../messages/message.service';
import { map, filter, find, reduce, each, keyBy, at , reject, includes} from 'lodash';
import { collectDeepNodes } from '@ngtools/webpack/src/transformers';

@Component({
  selector: 'app-favourite-user-collection-modal',
  templateUrl: './favourite-user-collection-modal.component.html',
  styleUrls: ['./favourite-user-collection-modal.component.scss']
})

export class FavouriteUserCollectionModalComponent implements OnInit {

  @Input() titleName: string;
  @Input() titleId: string;
  @Input() titleType: string;

  filteredCollections = new BehaviorSubject<UserCollectionDtoInterface[]>([]);
  AllColectionCount: number;
  newCollectionName: string;
  allUserCollections = [];
  nonValidUserActiveCollections = [];
  validUserActiveCollections = [];

  constructor(public activeModal: NgbActiveModal,
              private userCollections: UserCollectionsService,
              private authService: AuthService,
              private messageService: MessageService){}

  ngOnInit(): void {
    this.getAllPlainCollections();
  }


  getFavouriteList(){
    this.authService.getToken().then(token => {
      this.userCollections.getFavourites(['14'], token).subscribe(value => {
      });
    });
  }

  getActiveCollections(allCollections) {
    this.authService.getToken().then(token => {
      this.userCollections.getCollectionWithCertainItemId(this.titleId, token).subscribe(value => {
        const allActiveCollectionsId = map(value, 'id');
        this.validUserActiveCollections = filter(allCollections, v => includes(allActiveCollectionsId, v.id));
        this.nonValidUserActiveCollections = filter(allCollections, v => !includes(allActiveCollectionsId, v.id));
      });
    });
  }


  getAllCollections() {
    const filterValue = '';
    this.authService.getToken().then(token => {
      this.userCollections.findList(0, 5, 'id', 'asc', token, {name: filterValue})
        .subscribe((page: PageResult<UserCollectionDtoInterface>) => {
          this.AllColectionCount = page.totalElements;
          this.filteredCollections.next(page.content);
        });
    });
  }

  getAllPlainCollections() {
    this.authService.getToken().then(token => {
      this.userCollections.getPlainUserCollection(token)
        .subscribe(values => {
          this.allUserCollections = values;
          this.getActiveCollections(this.allUserCollections);
        });
    });
  }


  addItemToCollection(collection) {
    this.authService.getToken().then(token => {
      this.handleFavouriteResult(
        this.userCollections.insertUserCollectionItem(collection.id, this.titleId, this.titleType, token),
        'UserCollection.insertItem');
    });
  }

  createNewCollection(collectionName) {
    this.authService.getToken().then(token => {
      this.handleFavouriteResult(
        this.userCollections.insertUserCollectionItemAndCreate(collectionName, this.titleId, this.titleType, token),
        'UserCollection.createAndInsertItem');
    });
  }

  removeFromFavourites(collectionId) {
    this.authService.getToken().then(token => {
      this.handleFavouriteResult(
        this.userCollections.deleteUserCollectionItem(this.titleId, this.titleType, collectionId, token),
        'UserCollection.removeItem'
      );
    });
  }

  private handleFavouriteResult(favResult: Promise<any>, actionKey: string){
    favResult.then(result => {
      this.messageService.successMessage(actionKey, actionKey+'.desc');
      this.getAllPlainCollections();
    }, error1 => {
      this.messageService.errorMessage(actionKey+'.error', actionKey+'.desc.error');
    });
  }
}
